import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { set_timeout } from '@/utils/utils_client';
import { ReactNode } from 'react';

interface Props {
  page_type: string;
  page: ReactNode;
}

export function LAYOUT_PAGE__base({ page, page_type }: Props) {
  const dispatch = use_dispatch();

  const { is_all_data_loaded } = use_slice_workspace(['is_all_data_loaded']);
  const { global_need_show_first_animation } = use_slice_ui(['global_need_show_first_animation']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    dispatch(
      LOCAL__ui_set_string({
        key: 'global__page_type',
        value: page_type,
        valid_values: Object.values(ENUM__page_type).filter(item => typeof item == 'string'),
      }),
    );
  }, [page_type]);

  use_effect(() => {
    if (!is_all_data_loaded) return;
    if (global_need_show_first_animation) return; //variable already is true

    const timer = set_timeout(
      () => dispatch(LOCAL__ui_set_boolean({ value: true, key: 'global_need_show_first_animation' })),
      CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER,
    );

    return () => clearTimeout(timer);
  }, [is_all_data_loaded, global_need_show_first_animation]);

  /*
   * HTML
   */

  return (
    <div className="relative w-screen h-screen overflow-hidden cursor-default">
      <div
        className={`
            absolute inset-0
            transition-all duration-500
            ${is_all_data_loaded ? 'opacity-100 blur-none' : 'opacity-0 blur-sm'}
          `}
      >
        {page}
      </div>
    </div>
  );
}
